export default {
    en: {
        loginPlease: "Access is denied. Sign In, please",
        login: "Login (email)",
        password: "Password",
        enterButton: "Sign In",
    },
    uk: {
        loginPlease: "Доступ ограничен. Авторизуйтесь.",
        login: "Логин (email)",
        password: "Пароль",
        enterButton: "Войти",
    },
}